import axios from 'axios'
import { SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT } from 'cfgCommon/endpoints'

export async function getSavingsPlanByLeadId(leadId) {
    const url = `${SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT}/leads/${leadId}`
    const response = await axios.get(url)
    return response.data?.data
}
